import EmptySection from "./empty/EmptySection";
import Reservation from "./componentsWrappers/Reservation";
import Component from "./componentsWrappers/Component";
import { useIntl } from "react-intl";

const reservationSCGIcon = (width = "31", height = "32") => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 31 32"
    fill="none"
  >
    <path
      d="M19.2332 2.13333C19.2332 1.54423 18.7557 1.06667 18.1665 1.06667H9.6332C9.6332 0.477563 9.15566 0 8.56654 0C7.97742 0 7.49987 0.477563 7.49987 1.06667V1.13269C3.29047 1.65759 0.0332031 5.24843 0.0332031 9.6V23.4667C0.0332031 28.1795 3.85368 32 8.56654 32H22.4332C27.1461 32 30.9665 28.1795 30.9665 23.4667V9.6C30.9665 5.62379 28.247 2.28279 24.5665 1.3355V1.06667C24.5665 0.477563 24.089 0 23.4999 0C22.9108 0 22.4332 0.477563 22.4332 1.06667V3.73333C22.4332 4.32245 22.9108 4.8 23.4999 4.8C24.089 4.8 24.5665 4.32245 24.5665 3.73333V3.56417C27.0523 4.44277 28.8332 6.81339 28.8332 9.6V23.4667C28.8332 27.0013 25.9678 29.8667 22.4332 29.8667H8.56654C5.03192 29.8667 2.16654 27.0013 2.16654 23.4667V9.6C2.16654 6.4288 4.47299 3.7963 7.49987 3.28849V3.73333C7.49987 4.32245 7.97742 4.8 8.56654 4.8C9.15566 4.8 9.6332 4.32245 9.6332 3.73333V3.2H18.1665C18.7557 3.2 19.2332 2.72244 19.2332 2.13333Z"
      fill="#75757E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.2334 11.2C11.2334 8.84359 13.1436 6.93335 15.5001 6.93335C17.8565 6.93335 19.7667 8.84359 19.7667 11.2C19.7667 13.5564 17.8565 15.4667 15.5001 15.4667C13.1436 15.4667 11.2334 13.5564 11.2334 11.2ZM15.5001 9.06668C14.3219 9.06668 13.3667 10.0218 13.3667 11.2C13.3667 12.3782 14.3219 13.3334 15.5001 13.3334C16.6783 13.3334 17.6334 12.3782 17.6334 11.2C17.6334 10.0218 16.6783 9.06668 15.5001 9.06668Z"
      fill="#75757E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.8333 17.0667C9.88784 17.0667 7.5 19.4545 7.5 22.4V24.5333C7.5 25.1224 7.97755 25.6 8.56667 25.6H22.4333C23.0225 25.6 23.5 25.1224 23.5 24.5333V22.4C23.5 19.4545 21.1122 17.0667 18.1667 17.0667H12.8333ZM9.63333 22.4C9.63333 20.6327 11.066 19.2 12.8333 19.2H18.1667C19.934 19.2 21.3667 20.6327 21.3667 22.4V23.4667H9.63333V22.4Z"
      fill="#75757E"
    />
  </svg>
);

const reservationTrue = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3996 1.2C11.3996 0.868629 11.131 0.6 10.7996 0.6H5.99961C5.99961 0.268629 5.73099 0 5.39961 0C5.06823 0 4.79961 0.268629 4.79961 0.6V0.637137C2.43182 0.932394 0.599609 2.95224 0.599609 5.4V13.2C0.599609 15.851 2.74863 18 5.39961 18H13.1996C15.8506 18 17.9996 15.851 17.9996 13.2V5.4C17.9996 3.16338 16.4699 1.28407 14.3996 0.751221V0.6C14.3996 0.268629 14.131 0 13.7996 0C13.4682 0 13.1996 0.268629 13.1996 0.6V2.1C13.1996 2.43138 13.4682 2.7 13.7996 2.7C14.131 2.7 14.3996 2.43138 14.3996 2.1V2.00485C15.7978 2.49906 16.7996 3.83253 16.7996 5.4V13.2C16.7996 15.1882 15.1878 16.8 13.1996 16.8H5.39961C3.41139 16.8 1.79961 15.1882 1.79961 13.2V5.4C1.79961 3.6162 3.09699 2.13542 4.79961 1.84978V2.1C4.79961 2.43138 5.06823 2.7 5.39961 2.7C5.73099 2.7 5.99961 2.43138 5.99961 2.1V1.8H10.7996C11.131 1.8 11.3996 1.53137 11.3996 1.2Z"
      fill="#00086D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.89941 6.2999C6.89941 4.97441 7.97392 3.8999 9.29941 3.8999C10.6249 3.8999 11.6994 4.97441 11.6994 6.2999C11.6994 7.62539 10.6249 8.6999 9.29941 8.6999C7.97392 8.6999 6.89941 7.62539 6.89941 6.2999ZM9.29941 5.0999C8.63668 5.0999 8.09941 5.63717 8.09941 6.2999C8.09941 6.96263 8.63668 7.4999 9.29941 7.4999C9.96214 7.4999 10.4994 6.96263 10.4994 6.2999C10.4994 5.63717 9.96214 5.0999 9.29941 5.0999Z"
      fill="#00086D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.79981 9.6001C6.14296 9.6001 4.7998 10.9433 4.7998 12.6001V13.8001C4.7998 14.1315 5.06842 14.4001 5.3998 14.4001H13.1998C13.5312 14.4001 13.7998 14.1315 13.7998 13.8001V12.6001C13.7998 10.9433 12.4567 9.6001 10.7998 9.6001H7.79981ZM5.9998 12.6001C5.9998 11.606 6.8057 10.8001 7.79981 10.8001H10.7998C11.7939 10.8001 12.5998 11.606 12.5998 12.6001V13.2001H5.9998V12.6001Z"
      fill="#00086D"
    />
  </svg>
);
const ReservationWrapper = ({ data }: any) => {
  const intl = useIntl();
  return (
    <div className="m-0">
      <div className="flex gap-2 items-center">
        {data?.length
          ? reservationTrue()
          : reservationSCGIcon("17.4px", "18px")}
        <span
          className={`font-semibold text-lg ${
            data?.length || "text-[#75757E]"
          }`}
        >
          {intl.formatMessage({
            id: "todays_appointments",
          })}
        </span>
      </div>
      {data?.length ? (
        <Component>
          <Reservation
            title={intl.formatMessage({ id: "intl.form.titleNoReservations" })}
            description={intl.formatMessage({
              id: "intl.form.descriptionNoReservations",
            })}
            icon={reservationSCGIcon()}
            reservations={data}
          />
        </Component>
      ) : (
        <div className=" ">
          <EmptySection
            title={intl.formatMessage({ id: "intl.form.titleNoReservations" })}
            description={intl.formatMessage({
              id: "intl.form.descriptionNoReservations",
            })}
            icon={reservationSCGIcon()}
            paddingX="24px"
            paddingY="32px"
          />
        </div>
      )}
    </div>
  );
};

export default ReservationWrapper;
